<nz-result
  nzStatus="403"
  [nzTitle]="title"
  [nzSubTitle]="detailMessage || generalMessage || 'Hệ thống đã hết hạn bản quyền hoặc không hợp lệ.'"
>
  <div nz-result-content *ngIf="generalMessage || dateExpired">
    <div class="license-info">
      <p *ngIf="generalMessage && detailMessage">{{ generalMessage }}</p>
      <p *ngIf="dateExpired">
        <b>Hạn sử dụng:</b> {{ dateExpired | date: 'dd/MM/yyyy' }}
      </p>
      <p>
        Vui lòng liên hệ quản trị viên / bộ phận kinh doanh để được gia hạn.
      </p>
    </div>
  </div>
  <div nz-result-extra>
    <button nz-button nzType="primary" (click)="backToLogin()">
      Quay lại đăng nhập
    </button>
  </div>
</nz-result>
